import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";

import { styles } from "./manage-create-card.css";

@customElement("manage-create-card")
export class ManageCreateCard extends LitElement {
  @property({ type: String }) href = "#";
  @property({ type: String }) icon = "ph-arrow-right";
  @property({ type: String }) override title = "";
  @property({ type: String }) description = "";

  static override styles = styles;

  private _handleLinkClick(event: MouseEvent) {
    event.preventDefault();
    window.location.assign(this.href);

    setTimeout(() => {
      this.dispatchEvent(
        new CustomEvent("manage-create-modal-close", {
          bubbles: true,
          composed: true,
        }),
      );
    }, 100);
  }

  override render() {
    return html`
      <a href=${this.href} aria-label=${this.title} @click=${this._handleLinkClick}>
        <div class="card-content">
          <div class="card-icon">
            <slot name="icon"></slot>
          </div>
          <div class="card-text">
            <div class="card-title">${this.title}</div>
            <div class="card-description">${this.description}</div>
          </div>
        </div>
      </a>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "manage-create-card": ManageCreateCard;
  }
}
